import {withIMask} from './components/withIMask';
import {SpartanTextField} from './SpartanTextField';

export const SpartanPhoneFavtelField = withIMask(SpartanTextField, {
  mask: [{mask: '(000) 00000000'}],
});
